import Layout from '../../Layout';
import HeroSection from '../../components/home/HeroSection';
// import OurSolutions from '../../components/home/OurSolutions';
// import Features from '../../components/home/Features';
// import GetStarted from '../../components/home/GetStarted';
import Testimonials from '../../components/home/Testimonials';
// import Bonus from '../../components/home/Bonus';
import AboutOrnaMap from '../../components/home/AboutOrnaMap';
import YourExperience from '../../components/home/YourExperience';
import OurServices from '../../components/home/OurServices';
import AboutUs from '../../components/home/AboutUs';
import ComingSoon from '../../components/home/ComingSoon';

const HomePage = () => {
  return (
    <Layout>
      <main className='flex flex-col gap-24'>
        <HeroSection/>

        {/*<OurSolutions/>*/}

        <OurServices/>

        {/*<Features/>*/}

        {/*<GetStarted/>*/}

        <AboutUs/>

        <ComingSoon/>

        <Testimonials/>

        {/*<Bonus/>*/}

        <AboutOrnaMap/>

        <YourExperience/>
      </main>
    </Layout>
  );
};

export default HomePage;